export class AbortError extends Error {
  name = 'AbortError';
}
